<template>
  <the-dialog-box
    ref="dialogBox"
    :submit="submit"
    :submit-btn-text="item.id ? 'Update' : 'Create'"
  >
    <template slot="header">
      <span>{{ item.id ? 'Update' : 'Create' }} Supplier Item</span>
    </template>
    <template slot="body">
      <div class="d-flex flex-column ga-2">
        <v-text-field
          v-model="item.name"
          :rules="[(v) => !!v || `Name is required`]"
        >
          <template slot="label">
            Name<RedAsterisk />
          </template>
        </v-text-field>
        <v-text-field
          v-model="item.material_id"
          :rules="[(v) => !!v || `Material Id is required`]"
        >
          <template slot="label">
            Material Id<RedAsterisk />
          </template>
        </v-text-field>
        <div class="d-flex ga-3">
          <!-- <v-autocomplete
            v-model="item.uom_id"
            :items="uoms"
            item-text="name"
            item-value="id"
            :rules="[(v) => !!v || 'UOM is required']"
          >
            <template slot="label">
              UOM<RedAsterisk />
            </template>
          </v-autocomplete> -->
          <v-text-field
            v-model="item.price"
            :rules="[(v) => !!v || `Price is required`]"
            type="number"
          >
            <template slot="label">
              Price<RedAsterisk />
            </template>
          </v-text-field>
        </div>
        <v-autocomplete
          v-model="item.supplier_id"
          :items="suppliers"
          item-text="name"
          item-value="id"
          :rules="[(v) => !!v || 'Supplier is required']"
        >
          <template slot="label">
            Supplier<RedAsterisk />
          </template>
        </v-autocomplete>
        <v-autocomplete
          v-model="item.inventory_item_id"
          :items="inventoryItems"
          item-value="id"
          :item-text="
            (item) => item.material_id + ': ' + item.name
          "
          :rules="[(v) => !!v || 'Inventory Item is required']"
          no-data-text="Select a Class first"
          clearable
        >
          >
          <template slot="label">
            Inventory Item<RedAsterisk />
          </template>
          <!-- eslint-disable-next-line vue/no-template-shadow -->
          <template #item="{ item }">
            <v-chip
              class="mt-1 mb-1 mr-3"
              small
              text-color="white"
              style="cursor: pointer;"
              :color="item && item.classes ? item.classes.color : 'white'"
            >
              {{ item && item.classes ? item.classes.name : '' }}
            </v-chip><span style="font-weight: bold;">{{ item.material_id }}</span><span>{{ ': ' + item.name }}</span>
          </template>
          <!-- eslint-disable-next-line vue/no-template-shadow -->
          <template #selection="{ item }">
            <v-chip
              class="mt-1 mb-1 mr-3"
              small
              text-color="white"
              style="cursor: pointer;"
              :color="item && item.classes ? item.classes.color : 'white'"
            >
              {{ item && item.classes ? item.classes.name : '' }}
            </v-chip><span style="font-weight: bold;">{{ item.material_id }}</span><span>{{ ': ' + item.name }}</span>
          </template>
        </v-autocomplete>
      </div>
    </template>
  </the-dialog-box>
</template>

<script>
import { mapState, mapGetters } from 'vuex';

export default {
  components: {

  },
  props: {

  },
  data: () => ({
    item: null,
    itemDto: {
      id: 0,
      name: null,
      material_id: null,
      uom_id: null,
      supplier_id: null,
      inventory_item_id: null,
      price: null,
    },
    suppliers: [],
    uoms: [],
    inventoryItems: [],
  }),
  computed: {
    ...mapState({

    }),
    ...mapGetters([

    ]),
  },
  watch: {

  },
  created() {
    this.item = { ...this.itemDto };
    this.getUoms();
    this.getSuppliers();
    this.getInventoryItems();
  },
  methods: {
    async get(id) {
      if (!id) return;
      const submitModel = {
        filters: {
          id,
        },
      };
      const res = await this.$api.inventorySupplierItem.read(submitModel);
      if (!res || !res.data || res.data.length === 0) return;
      const firstIndex = 0;
      this.item = res.data[firstIndex];
    },
    async getUoms() {
      this.uoms = await this.$api.uom.get();
    },

    async getSuppliers() {
      this.suppliers = await this.$api.supplier.get();
    },

    async getInventoryItems() {
      const readModel = {
        filters:
        {
        },
      };

      const res = await this.$api.inventoryItem.readData(readModel);
      if (!res || !res.data) return;
      this.inventoryItems = res.data;
    },

    async checkIfExists() {
      if (!this.item || !this.item.inventory_item_id || !this.item.supplier_id) return false;
      const res = await this.$api.inventorySupplierItem.read({ filters: { inventory_item_id: this.item.inventory_item_id, supplier_id: this.item.supplier_id }});
      return res !== null && res.data.filter(x => x.id !== this.item.id).length > 0;
    },

    async submit() {
      if (!this.item) return false;
      const combinationExists = await this.checkIfExists();
      if (combinationExists) {
        this.$bus.$emit('showError', 'This Supplier and Inventory Item combination already exists');
        return;
      }

      let res;
      if (this.item.id) {
        res = await this.$api.inventorySupplierItem.update(this.item);
      } else {
        res = await this.$api.inventorySupplierItem.store(this.item);
      }

      if (!res) {
        this.$bus.$emit('showError');
        return false;
      }

      this.$bus.$emit('showSuccess');
      this.$emit('success');
      return res;
    },

    open(id) {
      if (id) {
        this.get(id);
      } else {
        this.item = { ...this.itemDto };
      }
      this.$refs.dialogBox.open();
    },
  },
};
</script>
